import type { ComponentType, SVGProps } from "react";
import PhBarbellFill from "~icons/ph/barbell-fill";
import PhCalendarDotsFill from "~icons/ph/calendar-dots-fill";
import PhCaretLeftBold from "~icons/ph/caret-left-bold";
import PhCaretRightBold from "~icons/ph/caret-right-bold";
import PhChartLineUpFill from "~icons/ph/chart-line-up-fill";
import PhCheckBold from "~icons/ph/check-bold";
import PhClockCounterClockwiseFill from "~icons/ph/clock-counter-clockwise-fill";
import PhDownloadSimpleBold from "~icons/ph/download-simple-bold";
import PhGearSixFill from "~icons/ph/gear-six-fill";
import PhHeartbeatFill from "~icons/ph/heartbeat-fill";
import PhMagnifyingGlassBold from "~icons/ph/magnifying-glass-bold";
import PhMonitorFill from "~icons/ph/monitor-fill";
import PhMoonStarsFill from "~icons/ph/moon-stars-fill";
import PhPencilSimpleFill from "~icons/ph/pencil-simple-fill";
import PhPlusBold from "~icons/ph/plus-bold";
import PhPillFill from "~icons/ph/pill-fill";
import PhScalesFill from "~icons/ph/scales-fill";
import PhSquaresFourFill from "~icons/ph/squares-four-fill";
import PhSunFill from "~icons/ph/sun-fill";
import PhTranslateBold from "~icons/ph/translate-bold";
import PhTrashFill from "~icons/ph/trash-fill";
import PhUploadSimpleBold from "~icons/ph/upload-simple-bold";
import PhXBold from "~icons/ph/x-bold";

type IconProps = SVGProps<SVGSVGElement>;
type IconComponent = ComponentType<IconProps>;

function decorativeIcon(Component: IconComponent, displayName: string): IconComponent {
  function Icon(props: IconProps) {
    return <Component {...props} aria-hidden="true" focusable="false" />;
  }
  Icon.displayName = displayName;
  return Icon;
}

export const OverviewIcon = decorativeIcon(PhSquaresFourFill, "OverviewIcon");
export const HistoryIcon = decorativeIcon(PhClockCounterClockwiseFill, "HistoryIcon");
export const TrendIcon = decorativeIcon(PhChartLineUpFill, "TrendIcon");
export const PlusIcon = decorativeIcon(PhPlusBold, "PlusIcon");
export const TherapyIcon = decorativeIcon(PhPillFill, "TherapyIcon");
export const WeightIcon = decorativeIcon(PhScalesFill, "WeightIcon");
export const VitalsIcon = decorativeIcon(PhHeartbeatFill, "VitalsIcon");
export const ExerciseIcon = decorativeIcon(PhBarbellFill, "ExerciseIcon");
export const AppointmentIcon = decorativeIcon(PhCalendarDotsFill, "AppointmentIcon");
export const TrashIcon = decorativeIcon(PhTrashFill, "TrashIcon");
export const EditIcon = decorativeIcon(PhPencilSimpleFill, "EditIcon");
export const CloseIcon = decorativeIcon(PhXBold, "CloseIcon");
export const SettingsIcon = decorativeIcon(PhGearSixFill, "SettingsIcon");
export const DownloadIcon = decorativeIcon(PhDownloadSimpleBold, "DownloadIcon");
export const UploadIcon = decorativeIcon(PhUploadSimpleBold, "UploadIcon");
export const ChevronLeftIcon = decorativeIcon(PhCaretLeftBold, "ChevronLeftIcon");
export const ChevronRightIcon = decorativeIcon(PhCaretRightBold, "ChevronRightIcon");
export const CheckIcon = decorativeIcon(PhCheckBold, "CheckIcon");
export const MonitorIcon = decorativeIcon(PhMonitorFill, "MonitorIcon");
export const SunIcon = decorativeIcon(PhSunFill, "SunIcon");
export const MoonIcon = decorativeIcon(PhMoonStarsFill, "MoonIcon");
export const LanguageIcon = decorativeIcon(PhTranslateBold, "LanguageIcon");
export const SearchIcon = decorativeIcon(PhMagnifyingGlassBold, "SearchIcon");
